<template>
  <div class="gs-app gs-refresh-controls gv-integration-form mr-4">
    <div
      class="flex flex-col w-full"
    >
      <div v-if="memberships.length > 0">
        <div class="flex flex-col">
          <div class="flex flex-row-reverse w-full">
            <gd-button
              size="auto"
              primary
              class="p-4"
              @click="showMembershipBox()"
              >{{
                $t('frontend_product_step8_add_new_membership')
              }}</gd-button
            >
          </div>
          <div
            v-if="
              selectedMemberships &&
              selectedMemberships.length > 0
            "
            class="mt-3"
          >
            <VuePerfectScrollbar
            style="max-height: 180px">
            <div
              v-for="(
                membership
              ) in selectedMemberships"
              :key="membership.id"
              class="flex flex-col mt-4"
            >
              <div
                class="flex flex-row border-t border-grey-400 border-solid pt-4"
              >
                <div class="w-1/12 mr-8">Add To</div>
                <div class="flex flex-row w-11/12">
                  <div class="w-3/4 flex flex-col">
                    <div class="flex flex-row">
                      <div class="font-bold mr-2">
                        {{ $t('frontend_membership') }}
                      </div>
                      <div>
                        {{
                          fetchMembershipName(
                            membership.membership_id
                          )
                        }}
                      </div>
                    </div>
                    <div class="flex flex-row">
                      <div class="font-bold mr-2">
                        {{ $t('frontend_access_level') }}
                      </div>
                      <div>
                        {{
                          fetchAccessLevelName(
                            membership.membership_id,
                            membership.membership_access_level_key
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="w-1/4 flex flex-row justify-end pr-4">
                    <gd-button
                      size="icon"
                      primary
                      title="Delete Membership"
                      class="mr-6"
                      @click="
                        deleteMembership(
                          membership.id
                        )
                      "
                    >
                      <i class="fas fa-trash" />
                    </gd-button>
                  </div>
                </div>
              </div>
            </div>
            </VuePerfectScrollbar>
          </div>
          <div v-else class="my-6 mr-4" >
            <label class="text-grey-dark">{{
              $t('frontend_product_step8_no_memberships')
            }}</label>
          </div>
        </div>
      </div>
      <div v-else>
        <label class="text-grey-dark">{{
          $t('frontend_product_step8_no_memberships_added')
        }}</label>
      </div>
    </div>
    <gs-named-modal
      name="add-membership-modal"
      :title="isEditing === false ? $t('frontend_groovevideo_add_new_membership') : $t('frontend_groovevideo_edit_membership')"
      width="80%"
    >
      <div class="gs-app gs-refresh-controls flex flex-col px-4 gv-integration-modal-body">
        <div class="mt-4">
          <div class="-mt-4">
            <div class="flex flex-row w-full">
              <div class="w-1/2 flex flex-col w-full mt-4 mr-4">
                <label
                  class="font-semibold text-sm text-grey-700 mb-2 text-left"
                  >{{ $t('frontend_select') }}
                  {{ $t('frontend_membership') }}</label
                >
                <select
                  v-model="membershipId"
                  class="w-full h-10 outline-none rounded-lg px-4 border border-grey-200"
                  @change="selectMembership($event)"
                >
                  <option value="">
                    {{ $t('frontend_select') }} {{ $t('frontend_membership') }}
                  </option>
                  <option
                    v-for="membership in this.memberships"
                    :key="membership.id"
                    :value="membership.id"
                    :data-name="membership.name"
                  >
                    {{ membership.name }}
                  </option>
                </select>
              </div>

              <div class="w-1/2 flex flex-col w-full mt-4">
                <label
                  class="font-semibold text-sm text-grey-700 mb-2 text-left"
                  >{{ $t('frontend_select') }}
                  {{ $t('frontend_access_level') }}</label
                >
                <select
                  v-model="membershipAccessLevelId"
                  class="w-full h-10 outline-none rounded-lg px-4 border border-grey-200"
                  @change="accesslevelid($event)"
                >
                  <option value="">
                    {{ $t('frontend_select') }}
                    {{ $t('frontend_access_level') }}
                  </option>
                  <option
                    v-for="accessLevel in this.access_levels"
                    :key="accessLevel.secret_key"
                    :value="accessLevel.secret_key"
                    :data-name="accessLevel.name"
                  >
                    {{ accessLevel.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row w-full mb-6 justify-end">
          <gd-button
            v-if="isEditing == false"
            :primary="this.addbtn"
            class="text-center mt-4"
            size="large"
            @click="data != '' ? addMembershipField() : null"
            >{{ $t('frontend_add') }}</gd-button
          >
        </div>
      </div>
    </gs-named-modal>
  </div>
</template>

<script>
import themeConfig from '@/theme/themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Integration from '@/models/MembershipIntegration';
import Mailsequence from '@/models/Mail/Mailsequence';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'AddMember',
  props: {
    model: {
      required: true,
    },
    memberships: {
      required: true,
    },
    selectedMembership: {
      required: true,
    },
    eventId: {
      required: true,
    },
    eventType: {
      required: true,
    },
    optinId: {},
  },
  data() {
    return {
      clearable: false,
      closeOnSelect: true,
      clearOnSelect: true,
      video: this.model,
      selectionSubmitted: false,
      isSequenceSelectionInvalid: false,
      localModel: this.model,
      selectedMemberships: this.selectedMembership,
      membershipId: '',
      membershipAccessLevelId: '',
      access_levels: [],
      isEditing: false,
      addbtn: false,
    };
  },

  computed: {},

  components: {
    Treeselect,
    VuePerfectScrollbar
  },

  async created() {
  //  this.showLoader();
  //  this.hideLoader();
  },

  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },
    save() {
      
    },
    fetchMembershipName(membershipId) {
      const membership = this.memberships.find((obj) => {
        return obj.id == membershipId;
      });

      if (membership) {
        return membership.name;
      }
      return 'N/A';
    },
    fetchAccessLevelName(membershipId, accessLevelSecretKey) {
      const membership = this.memberships.find((obj) => {
        return obj.id == membershipId;
      });

      if (membership) {
        const accessLevels = membership.access_level;

        if (accessLevels) {
          const accessLevel = accessLevels.find((obj) => {
            return obj.secret_key == accessLevelSecretKey;
          });

          if (accessLevel) {
            return accessLevel.name;
          }
          return 'N/A';
        }
        return 'N/A';
      }
      return 'N/A';
    },
    selectMembership(event) {
      this.model.accesslevelid = '';
      this.addbtn = false;
      this.data = [];
      const selectedMembership = this.memberships.find((ele) => {
        return ele.id === this.membershipId;
      });

      if (selectedMembership) {
        this.access_levels = selectedMembership.access_level;
      } else {
        this.access_levels = [];
      }
    },
    async addMembershipField() {
      
      if(this.membershipId && this.membershipAccessLevelId){
      
        const completeMembershipInfo = {};
        completeMembershipInfo.membership_id = this.membershipId;
        completeMembershipInfo.secret_key = this.membershipAccessLevelId;
        completeMembershipInfo.optin_id = this.optinId;
        completeMembershipInfo.event_id = this.eventId;
        completeMembershipInfo.event_type = this.eventType;
        this.showLoader();
      
        const selectedMembershipIntegration = await this.model
                            .membershipIntegration()
                            .attach(completeMembershipInfo);

        this.selectedMemberships.push(new Integration(selectedMembershipIntegration.data.data));
        
        this.hideLoader();
        this.$root.$emit('modal-close', 'add-membership-modal');
        this.membershipId = '';
        this.membershipAccessLevelId = '';
      }
      
      
    },
    async deleteMembership(membershipIntegrationId){
     
     this.showLoader();
     console.log('delete', membershipIntegrationId,this.selectedMemberships)
      // const membership = this.selectedMemberships.find((m) => m.id === membershipIntegrationId);
      const membership = await this.model.membershipIntegration().$find(membershipIntegrationId);
      const response = await membership.for(this.model).delete();
      if (
        typeof response.data !== 'undefined' &&
        typeof response.data.status !== 'undefined' &&
        response.data.status == true
      ) {
        const deletedMembership = this.selectedMemberships
            .map((item) => item.id)
            .indexOf(membershipIntegrationId);
          this.selectedMemberships.splice(deletedMembership, 1);
        }
      this.hideLoader();    
    },
    showMembershipBox() {
      this.integrationType = '';
      this.$root.$emit('modal-open', 'add-membership-modal');
    },
    accesslevelid() {
      const selectedMembership = this.memberships.find((ele) => {
        return ele.id === this.membershipId;
      });
      const selectedAccessLevel = this.access_levels.find((ele) => {
        return ele.secret_key === this.membershipAccessLevelId;
      });
     
      if (selectedAccessLevel) {
        this.membershipdata = {
          membership_id: this.membershipId,
          secret_key: this.membershipAccessLevelId,
        };
        if (this.isEditing == false) {
          this.data.push(this.membershipdata);
        }

        this.addbtn = true;
      } else {
        this.dataname = '';
        this.addbtn = false;
      }
    },
    sequenceRemoved(node) {
      const sequenceIndex = this.localModel.assignsequences.findIndex((ele) => {
        return ele.id === node.id;
      });
      this.localModel.assignsequences.splice(sequenceIndex, 1);
      this.validateSequenceAdded();
    },
    validateSequenceAdded() {
      if (
        this.localModel.assignsequences &&
        this.localModel.assignsequences.length
      ) {
        this.isSequenceSelectionInvalid = false;
      } else {
        this.isSequenceSelectionInvalid = true;
      }
    },
    validate() {
      this.selectionSubmitted = true;
      return true;
    },
  },
};
</script>

<style lang="scss">
.form-setup-radio.flex {
  margin: 0;
  padding: 0;
  border: none;
  height: auto;
  position: relative;
  .ml-2 {
    margin: 0;
    label {
      color: #191d3a;
    }
    .text-grey-500 {
      font-size: 14px;
      line-height: 24px;
      color: #545671;
      margin-top: 8px;
    }
  }
  .w-6 {
    height: 24px;
    margin: 0;
    position: absolute;
    right: 0;
    top: 16px;
  }
}
</style>

<style>
.gv-integration-form { padding: 20px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface); }
.gv-integration-modal-body { gap: 12px; padding: 20px; }
@media (max-width: 640px) { .gv-integration-form { margin-right: 0 !important; padding: 16px; } .gv-integration-modal-body .flex.flex-row { flex-direction: column; } .gv-integration-modal-body .w-1\/2 { width: 100% !important; } }
</style>
